import { useEffect, useState } from 'react';
import { clearSession, loadSession, signIn } from './auth';
import type { Session, TabId } from './types';
import { LeadsTab } from './tabs/Leads';
import { CalendarTab } from './tabs/Calendar';
import { AgentTab } from './tabs/Agent';
import { PhoneTab } from './tabs/Phone';
import { ReviewsTab } from './tabs/Reviews';

const TABS: { id: TabId; label: string }[] = [
  { id: 'leads', label: 'Leads' },
  { id: 'calendar', label: 'Calendar' },
  { id: 'agent', label: 'Agent' },
  { id: 'phone', label: 'Phone' },
  { id: 'reviews', label: 'Reviews' },
];

export function App() {
  const [session, setSession] = useState<Session | null>(loadSession());
  const [tab, setTab] = useState<TabId>('leads');
  const [email, setEmail] = useState('aaronbrightman1@gmail.com');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setSession(loadSession());
  }, []);

  if (!session) {
    return (
      <div className="login">
        <form
          className="box"
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            setErr('');
            try {
              setSession(await signIn(email, password));
            } catch (ex) {
              setErr(ex instanceof Error ? ex.message : 'Sign-in failed');
            } finally {
              setBusy(false);
            }
          }}
        >
          <h1>LeadsIRL</h1>
          <p className="sub">Contractor CRM</p>
          <label>
            Email
            <input value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
          </label>
          <label>
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          </label>
          {err && <p className="err">{err}</p>}
          <button className="primary" disabled={busy} type="submit">{busy ? 'Signing in…' : 'Sign in'}</button>
        </form>
      </div>
    );
  }

  return (
    <div className="app">
      <aside className="nav">
        <div className="brand">
          LeadsIRL
          <small>Demo shop · {session.clientId}</small>
        </div>
        {TABS.map((t) => (
          <button key={t.id} className={`tab ${tab === t.id ? 'on' : ''}`} onClick={() => setTab(t.id)}>
            {t.label}
          </button>
        ))}
        <div className="spacer" />
        <div className="who">{session.email}</div>
        <button
          className="out"
          onClick={() => {
            clearSession();
            setSession(null);
          }}
        >
          Sign out
        </button>
      </aside>
      <main className="main">
        {tab === 'leads' && <LeadsTab session={session} />}
        {tab === 'calendar' && <CalendarTab session={session} />}
        {tab === 'agent' && <AgentTab session={session} />}
        {tab === 'phone' && <PhoneTab session={session} />}
        {tab === 'reviews' && <ReviewsTab />}
      </main>
    </div>
  );
}
